import * as ko from 'knockout';
import entityBase from 'entityBase';

export class c_cust_portal_function extends entityBase {
    function_id: KnockoutObservable<string>;
    message_id : KnockoutObservable<string>;
    read_only  : KnockoutObservable<string>;
    sequence   : KnockoutObservable<number>;
    url        : KnockoutObservable<string>;

    constructor(item: any){
        super();
        this.function_id = ko.observable(item.function_id).extend({ maxLength: 128 });
        this.message_id  = ko.observable(item.message_id).extend({ maxLength: 250 });
        this.read_only   = ko.observable(item.read_only).extend({ maxLength: 50 });
        this.sequence    = ko.observable(item.sequence);
        this.url         = ko.observable(item.url).extend({ maxLength: 50 });
    }
}


